import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from '@Redux/type';
import { AppState } from '@Redux/store';
import classNames from 'classnames';
import { DragDropContext, Draggable, Droppable } from '@hello-pangea/dnd';

import ArmyListUnitComponent from './ArmyListUnitComponent';
import { container } from '@Container';
import { ArmyListAction, ArmyListUnitAction } from '@Redux/actions';
import { TYPES } from '@Types';
import { ArmyListUnitView } from '@Selectors/builder/myArmyList/make/view/ArmyListUnitView';
import CreateArmyListUnit from '@Builder/myArmyList/make/unit/new/create-army-list-unit';
import Titre from '@Components/utils/titre/titre.component';
import { SectionHeader } from '@Builder/myArmyList/make/army-list-unit.section.styled';

interface IArmyListUnitShowV2Props {
  name: string;
  good: boolean;
  longTotal: string;
  armyListUnits: Array<ArmyListUnitView>;
  organisationId: number | string;
}

const getItemStyle = (isDragging: boolean, draggableStyle: any) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: 'none',

  // change background colour if dragging
  background: isDragging ? 'lightgreen' : 'grey',

  // styles we need to apply on draggables
  ...draggableStyle,
});

const getListStyle = (isDraggingOver: boolean) => ({
  background: isDraggingOver ? 'lightblue' : 'lightgrey',
});

const ArmyList_unitSection: React.FC<ArmyListUnitSectionProps> = ({
  name,
  good,
  longTotal,
  armyListUnits,
  organisationId,
  sortArmyList,
  onDragEnd,
}) => {
  return (
    <section className="mb-2">
      <SectionHeader className="text-center p-1 flex">
        <Titre texte={name} niveau={3} className="m-0"></Titre>
        <small className={classNames({ 'highlight-red': !good })}>
          ( {longTotal} )
        </small>
        <button
          className="float-end border-0 text-white bg-transparent"
          onClick={() => sortArmyList()}
        >
          <i className="fa-solid fa-arrow-down-short-wide" />
        </button>
      </SectionHeader>
      <div className="army_list_units_overview ui-sortable ms-3">
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId={`droppable-${organisationId}`}>
            {(provided: any, snapshot: any) => (
              <div
                {...provided.droppableProps}
                ref={provided.innerRef}
                style={getListStyle(snapshot.isDraggingOver)}
              >
                {armyListUnits.map((item: ArmyListUnitView) => (
                  <Draggable
                    draggableId={`${item.id}`}
                    key={`${item.id}`}
                    index={item.position}
                  >
                    {(provided: any, snapshot: any) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={getItemStyle(
                          snapshot.isDragging,
                          provided.draggableProps.style,
                        )}
                      >
                        <ArmyListUnitComponent
                          armyListUnit={item}
                          showOrganisation={false}
                        />
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>
      <div className="d-lg-none">
        <CreateArmyListUnit organisationId={organisationId} />
      </div>
    </section>
  );
};

const mapStateToProps = (
  _: AppState,
  owsProps: IArmyListUnitShowV2Props,
) => ({
  name: owsProps.name,
  good: owsProps.good,
  longTotal: owsProps.longTotal,
  armyListUnits: owsProps.armyListUnits,
  organisationId: owsProps.organisationId,
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  const armyListAction = container.get<ArmyListAction>(
    TYPES.Actions.ArmyListAction,
  );
  const armyListUnitAction = container.get<ArmyListUnitAction>(
    TYPES.Actions.ArmyListUnitAction,
  );
  return {
    sortArmyList: () => dispatch(armyListAction.sortArmyListAction()),
    onDragEnd: (result: any) => {
      if (!result.destination) {
        return;
      }
      console.log('event', {
        armyListUnitId: result.draggableId,
        source: result.source.index,
        destination: result.destination.index,
      });
      dispatch(
        armyListUnitAction.moveArmyListUnit({
          armyListUnitId: result.draggableId,
          source: result.source.index,
          destination: result.destination.index,
        }),
      );
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ArmyList_unitSection);

type ArmyListUnitSectionProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>;
